import boletaApi from "./boletaApi";

export const loginAuthentication = async (credentials) => {
  try {
    return await boletaApi.post("/loginAuthentication", {
      email: credentials.email,
      password: credentials.password,
    });
  } catch (error) {
    const { response } = error;
    return response;
  }
};
